<template>
  <div class="home">
    <HelloWorld/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/LoginComponent.vue'
import BusinessPartners from './BusinessPartners.vue';
import DashboardView from './DashboardView.vue';

export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    BusinessPartners,
    DashboardView,
  }
}
</script>

<style scoped>
*{
  margin: 0;
}
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; 
  width: 100vw;  
  background-image: url('@/assets/login.webp');
  background-size: cover;       
  background-position: center;   
  background-repeat: no-repeat;  
}
</style>
